export default "__VITE_ASSET__ran$RMtl__"